"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _clientAwsS = require("@devsta/client-aws-s3");

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _EntityFormBlock = _interopRequireDefault(require("../../../../../../../common/components/EntityFormBlock"));

require("../styles/_branding.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getDate = function getDate(date) {
  return (0, _moment.default)(date).format('YYYY/MM/DD [at] hh:mm A');
};

var Branding = /*#__PURE__*/function (_Component) {
  _inherits(Branding, _Component);

  var _super = _createSuper(Branding);

  function Branding() {
    var _this;

    _classCallCheck(this, Branding);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, apolloClient, getOrganisationSubBrand, _yield$getOrganisatio, error, data, brandWithImage;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, apolloClient = _this$props.apolloClient, getOrganisationSubBrand = _this$props.getOrganisationSubBrand;
              _context.next = 3;
              return getOrganisationSubBrand();

            case 3:
              _yield$getOrganisatio = _context.sent;
              error = _yield$getOrganisatio.error;
              data = _yield$getOrganisatio.data;

              if (!(error || !data.getOrganisationSubBrand)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              _context.prev = 8;
              _context.next = 11;
              return (0, _clientAwsS.replaceBucketKeysWithUrls)({
                apiClient: apolloClient,
                data: data.getOrganisationSubBrand,
                substitutedKeys: ['profileImageKey']
              });

            case 11:
              brandWithImage = _context.sent;

              _this.setState({
                brand: brandWithImage
              });

              _context.next = 17;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](8);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 15]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "goToBrand", function () {
      var history = _this.props.history;
      var brand = _this.state.brand;

      if (!brand || !brand.subBrandId) {
        return;
      }

      history.rootPush("/organisation/brand/".concat(brand.subBrandId));
    });

    _defineProperty(_assertThisInitialized(_this), "renderBrandItem", function (_ref2) {
      var subBrandGroupId = _ref2.subBrandGroupId,
          name = _ref2.name,
          description = _ref2.description,
          notes = _ref2.notes,
          updatedAt = _ref2.updatedAt,
          assetIds = _ref2.assetIds;
      var firstAssetId = assetIds && assetIds[0];
      return (/*#__PURE__*/_react.default.createElement(_EntityFormBlock.default, {
          className: "video-overview-branding__card-item",
          imageSize: "90px",
          imageContent: firstAssetId && /*#__PURE__*/_react.default.createElement("div", {
            className: "video-overview-branding__card-item__asset-preview"
          }, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
            width: "90px",
            height: "90px",
            assetId: firstAssetId,
            key: firstAssetId
          })),
          options: [],
          key: subBrandGroupId
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "video-overview-branding__card-item__title"
        }, name), /*#__PURE__*/_react.default.createElement("p", {
          className: "video-overview-branding__card-item__description"
        }, description), /*#__PURE__*/_react.default.createElement("p", {
          className: "video-overview-branding__card-item__notes"
        }, notes), /*#__PURE__*/_react.default.createElement("p", {
          className: "video-overview-branding__card-item__date"
        }, "Updated on ".concat(getDate(updatedAt))))
      );
    });

    _this.state = {
      brand: void 0
    };
    return _this;
  }

  _createClass(Branding, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var brand = this.state.brand;

      if (!brand) {
        return null;
      }

      var name = brand.name,
          profileImageKey = brand.profileImageKey,
          description = brand.description,
          updatedAt = brand.updatedAt,
          videoTemplates = brand.videoTemplates,
          styleguides = brand.styleguides,
          colorPalettes = brand.colorPalettes;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "video-overview-branding"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "video-overview-branding__overview"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.ImageCard, {
          width: "100%",
          title: name,
          imageUrl: profileImageKey,
          onClick: this.goToBrand
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "video-overview-branding__overview__details"
        }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
          className: "video-overview-branding__overview__details__title"
        }, description), /*#__PURE__*/_react.default.createElement("p", {
          className: "video-overview-branding__overview__details__subtitle"
        }, "Updated on ".concat(getDate(updatedAt)))), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          onClick: this.goToBrand,
          type: "SECONDARY",
          small: true
        }, "VIEW BRANDING")), /*#__PURE__*/_react.default.createElement("hr", null), styleguides.map(function (guide) {
          return _this2.renderBrandItem(guide);
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "video-overview-branding__items-container"
        }, videoTemplates.map(function (template) {
          return _this2.renderBrandItem(template);
        }), colorPalettes.map(function (palette) {
          return _this2.renderBrandItem(palette);
        })))
      );
    }
  }]);

  return Branding;
}(_react.Component);

exports.default = Branding;